import { FC } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { useModalControl } from '@frontend/design-system';
import { CallFlagsData } from '../../types';
import { generateTrackingId } from '../../utils';
import { CorrectionBannerConfig } from '../../utils/call-analysis-util';
import { EditHistoryModal } from '../modal/edit-history-modal';
import { CorrectionBanner } from './correction-banner';

interface EditBannerProps {
  isDemoAccount?: boolean;
  call: CallIntelTypes.Call;
  source: CallIntelTypes.PanelSource;
  callFlags: CallFlagsData;
  isFormEdited: boolean;
  correctionBannerConfig: CorrectionBannerConfig;
  onMakeCorrection: () => void;
  onUpdateCall: (updatedFields: Partial<CallIntelTypes.Call>, isRestore?: boolean) => void;
}

export const EditBanner: FC<EditBannerProps> = ({
  isDemoAccount,
  correctionBannerConfig,
  source,
  call,
  callFlags,
  onMakeCorrection,
  onUpdateCall,
}) => {
  const { modalProps: editHistoryModalProps, openModal: openEditHistoryModal } = useModalControl();

  const { canMakeCorrection, isReviewed, showEditHistory } = correctionBannerConfig;

  return (
    <>
      <CorrectionBanner
        canMakeCorrection={canMakeCorrection}
        isReviewed={isReviewed}
        showEditHistory={showEditHistory}
        onMakeCorrection={onMakeCorrection}
        onViewEditHistory={openEditHistoryModal}
        trackingIds={{
          correctionBtn: generateTrackingId({
            component: 'call-analysis',
            context: 'make-correction-btn-click',
            isDemoAccount,
          }),
          viewHistory: generateTrackingId({
            component: 'call-analysis',
            context: 'view-edit-history-btn-click',
            isDemoAccount,
          }),
        }}
      />
      {editHistoryModalProps.show && (
        <EditHistoryModal
          modalProps={editHistoryModalProps}
          onClose={editHistoryModalProps.onClose}
          updateEditedCallInList={onUpdateCall}
          source={source}
          call={call}
          isDemoAccount={isDemoAccount}
          {...callFlags}
        />
      )}
    </>
  );
};
